"use strict";
/* globals module */
/**
 * @module companyRoute
 * @description Baasic Company Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Company Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
;
var _1 = require("./");
var contracts_1 = require("../../../core/contracts");
var CompanyRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CompanyRoute, _super);
    function CompanyRoute(appOptions, companyBatchRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.companyBatchRoute = companyBatchRoute;
        _this.findRoute = 'lookups/companies/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.createRoute = 'lookups/companies';
        _this.getRoute = 'lookups/companies/{id}/{?embed,fields}';
        _this.updateRoute = 'lookups/companies/{id}';
        _this.deleteRoute = 'lookups/companies/{id}';
        return _this;
    }
    Object.defineProperty(CompanyRoute.prototype, "batch", {
        get: function () {
            return this.companyBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing company properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain company subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the company property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example companyRoute.find({searchQuery: '<search-phrase>'});
     **/
    CompanyRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @example companyRoute.create();
     **/
    CompanyRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @param id Company id which uniquely identifies resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example companyRoute.get();
     **/
    CompanyRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    CompanyRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    CompanyRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    CompanyRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.CompanyBatchRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.CompanyBatchRoute !== "undefined" && _1.CompanyBatchRoute) === "function" ? _b : Object])
    ], CompanyRoute);
    return CompanyRoute;
}(common_1.BaseRoute));
exports.CompanyRoute = CompanyRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
